import * as React from 'react';
import { useState, useCallback, useEffect } from 'react';
import { TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { CustomSetting } from 'types/types';

const useStyles = makeStyles((theme) => ({
  textField: {
    width: '45%',
    whiteSpace: 'pre-line',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(2)
  },
  inputTextField: {
    fontSize: 13
  }
}));

type TextfieldSectionProps = {
  inputSetting: CustomSetting;
  initialSelectValue: any;
  setSave: React.Dispatch<
    React.SetStateAction<Record<string, string | boolean>>
  >;
  isFieldChanged: boolean;
  setChangedFields: React.Dispatch<React.SetStateAction<any>>;
  isFieldInvalid: boolean;
  isValidationRequired: boolean;
};

export const TextfieldSection: React.FC<TextfieldSectionProps> = ({
  inputSetting,
  initialSelectValue,
  setSave,
  isFieldChanged,
  setChangedFields,
  isFieldInvalid,
  isValidationRequired
}: TextfieldSectionProps) => {
  const classes = useStyles();
  const id = inputSetting.id as string;

  const [textInput, setTextInput] = useState(initialSelectValue);

  const handleTextFieldChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setTextInput(event.target.value);
      setChangedFields((prev: any) => ({
        ...prev,
        [id]: true
      }));
    },
    [id, setChangedFields]
  );

  useEffect(() => {
    if (!id) return;

    setSave((prev) => ({ ...prev, [id]: textInput }));
  }, [id, textInput, setSave, setChangedFields]);

  const inputProps = {
    className: classes.inputTextField,
    ...(id === 'delimiterCharacter' ? { maxLength: 1 } : {})
  };
  const isRequired =
    inputSetting?.isRequired === undefined || inputSetting?.isRequired === true;

  return (
    <TextField
      {...(id === 'probability' ? { type: 'number' } : {})}
      size="small"
      className={classes.textField}
      error={
        isValidationRequired &&
        (isFieldChanged
          ? isRequired && textInput.trim() === ''
          : isFieldInvalid)
      }
      inputProps={inputProps}
      value={textInput}
      onChange={handleTextFieldChange}
      helperText={inputSetting.helperTextValue}
      data-testid="textfield-section"
    />
  );
};
